import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { XCircle, ArrowLeft, ShoppingCart } from "lucide-react";
import { Fade } from "react-awesome-reveal";
import { Background } from "../../components/background";
import { trackEvent } from "../../helpers";
import {
  PageWrapper,
  SuccessContainer,
  IconWrapper,
  Title,
  Message,
  InfoBox,
  InfoText,
  ButtonGroup,
  PrimaryButton,
  SecondaryButton,
} from "./success.styles";
import styled from "styled-components";

const CancelIconWrapper = styled(IconWrapper)`
  background: rgba(239, 68, 68, 0.15);
  border-color: rgba(239, 68, 68, 0.3);

  svg {
    color: #ef4444;
  }
`;

const CancelInfoBox = styled(InfoBox)`
  background: rgba(239, 68, 68, 0.1);
  border-color: rgba(239, 68, 68, 0.3);
`;

export const CheckoutCancel = () => {
  const navigate = useNavigate();

  useEffect(() => {
    // Track checkout cancellation
    trackEvent('checkout_cancelled', {
      product: 'The Unhinged Guide to Breaking Into Tech',
      reason: 'user_cancelled',
    });
  }, []);

  return (
    <>
      <Background />
      <PageWrapper>
        <Fade triggerOnce>
          <SuccessContainer>
            <CancelIconWrapper>
              <XCircle size={48} />
            </CancelIconWrapper>

            <Title>Payment Cancelled</Title>
            <Message>
              Your payment was cancelled. No charges were made to your account.
            </Message>

            <CancelInfoBox>
              <InfoText>
                If you encountered any issues during checkout or have questions
                about the product, please don't hesitate to reach out to
                hello@reneelouise.tech
              </InfoText>
            </CancelInfoBox>

            <ButtonGroup>
              <PrimaryButton onClick={() => navigate("/the-guide")}>
                <ShoppingCart size={20} />
                Return to Shop
              </PrimaryButton>
              <SecondaryButton onClick={() => navigate("/")}>
                <ArrowLeft size={20} />
                Go Home
              </SecondaryButton>
            </ButtonGroup>
          </SuccessContainer>
        </Fade>
      </PageWrapper>
    </>
  );
};
